var map = {
	"./SVG/compass2.svg": 92,
	"./SVG/info.svg": 93,
	"./SVG/library.svg": 94,
	"./SVG/location.svg": 95,
	"./SVG/location1.svg": 96,
	"./SVG/map.svg": 97,
	"./SVG/office.svg": 98,
	"./SVG/search.svg": 99,
	"./ankara.jpg": 100,
	"./bank.jpg": 101,
	"./icon.png": 49,
	"./navigation.jpg": 102,
	"./sprites.svg": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;